import React, { Component } from 'react';
import classNames from 'classnames';
import { SelectFileButton } from 'lib/editor/DraftEditor/toolbar';

const CONFIG = {
	word: { title: '导入 Word 文档', accept: '.doc, .docx' },
	ppt: { title: '导入 PowerPoint 文档', accept: '.ppt, .pptx' },
	attachment: { title: '导入附件', accept: '.pdf, .zip, .rar' },
};

export function ImportButton({ type, theme, store, onInsert }) {
	const disabled = store.getEditorEnviorment() !== 'root';
	const { title, accept } = CONFIG[type];

	return (
		<SelectFileButton
			theme={theme}
			disabled={disabled}
			accept={accept}
			icon={type}
			title={title}
			onSelect={onInsert}>
		</SelectFileButton>
	)
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/fileImportPlugin/component/ImportButton.jsx